import { DropdownOption } from '../../interfaces/entities/forms/dropdown-options'

export const transformPerPage = (perPageOptions: number[]): DropdownOption[] => perPageOptions.map(p => ({
  key: p,
  value: p,
  text: `${p} records per page`,
}))
